import { Grid2, Link, styled, lighten } from '@mui/material';
import { AppTypography } from '../../AppTypography/AppTypography';

const StyledLink = styled(Link)(({ theme }) => ({
	color: theme.palette.insurance.primary,
	textDecorationColor: lighten(theme.palette.insurance.primary, 0.5),
}));
interface ContactItemProps {
	icon: React.ReactNode;
	href: string;
	text: string;
}
export const ContactItem = ({ icon, href, text }: ContactItemProps) => {
	return (
		<Grid2 container alignItems={'center'}>
			<Grid2 mr={1} maxHeight={18}>
				{icon}
			</Grid2>
			<Grid2>
				<StyledLink href={href}>
					<AppTypography color={'inherit'} element={'body2'} text={text} noWrap textAlign='left' />
				</StyledLink>
			</Grid2>
		</Grid2>
	);
};
